import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Clients from "./pages/Clients";
import Privacy from './pages/Privacy';
import Terms from './pages/Terms-and-Conditions';
import Home from './pages/Home';
//import Wip from './pages/Wip';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} /> 
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/privacy" element ={<Privacy />}/>
        <Route path="/terms-and-conditions" element={<Terms />}/>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
